import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../providers/TacticHooksProvider";

/**
 * Current and pending webhook signing secrets for the organization.
 * Resolves to null when no secret has been created yet.
 */
export const useWebhookSigningSecretsQuery = () => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["useWebhookSigningSecretsQuery", apiClient.slug],

    queryFn: async () => {
      return apiClient.orgOrOfficeSettings.getWebhookSigningSecrets();
    },

    enabled: !!apiClient.slug
  });
};
